import styles from './table-products-filter.module.scss';
import { useState } from 'react';
import Checkbox from '../checkbox/checkbox';
import FormControl from '../form-control/form-control';
import { ListItemText } from '../list/list';
import { MenuItem } from '../menu/menu';
import TextField, { Autocomplete } from '../text-field/text-field';
import { Chip } from '@frontend-workspace/react-shared-lib';
import { t } from 'i18next';

export interface iRelationProduct {
  parentName: string,
  groupName: string,
  productName: string,
  id: string,
  relatedProductIds: [string],
  vismaItemIds: [string],
  webAppUrl: string,
  mainProductId: string,
  moduleIds: [string],
  iconUrl: string,
  ticketCategoryId: number,
  doesNotHaveNimbusLicensing: boolean,
  description: string,
  requirements: string,
  productPageUrl: string,
  productCode: string
}
export interface iRelationProductGroups {
  groupName: string,
  mainProducts: iRelationProduct[],
  id: string
}
/* eslint-disable-next-line */
export interface TableProductsFilterProps {
  products: iRelationProduct[];
  selectedProductGroupIds: string[];
  setSelectedProductGroupIds: (selectedGroupIds: string[]) => void
}

export function TableProductsFilter(props: TableProductsFilterProps) {
  return (
    <div className="pe-3">
      <ProductgroupSelection
        relationProducts={props.products}
        selectedProductIds={props.selectedProductGroupIds}
        setSelectedProductIds={props.setSelectedProductGroupIds}
      />
    </div>
  );
}

function ProductgroupSelection(props: {
  selectedProductIds: string[],
  relationProducts: iRelationProduct[],
  setSelectedProductIds: (selectedProductIds: string[]) => void
}) {
  const [productIds, setProductIds] = useState(props.selectedProductIds);

  const handleProductChange = (productId: string) => {
    const newProductIds = productIds.includes(productId)
      ? productIds.filter(id => id !== productId)
      : [...productIds, productId];
    setProductIds(newProductIds);
  }
  const onClose = (event: any) => props.setSelectedProductIds(productIds);

  const getOptionLabel = (productId: any) => {
    const relationProduct = props.relationProducts.find((product) => product.id === productId);
    return `${relationProduct?.productName}`;
  };

  return (
    <FormControl sx={{ width: 600 }}>
      <Autocomplete
        multiple
        limitTags={1}
        value={productIds}
        onClose={onClose}
        getOptionLabel={(productId) => getOptionLabel(productId)}
        renderTags={(value, getTagProps) => {
          const numTags = value.length;
          const limitTags = 3;
          return (
            <>
              {value.slice(0, limitTags).map((option, index) => (
                <Chip
                  {...getTagProps({ index })}
                  key={index}
                  label={getOptionLabel(option)}
                />
              ))}
              {numTags > limitTags && ` +${numTags - limitTags}`}
            </>
          );
        }}
        options={props.relationProducts}
        renderInput={(params: any) => (
          <TextField
            {...params}
            fullWidth
            label={t("standard.selectProducts")}
            onKeyDown={(event) => {
              if (event.key === 'Enter' && event.target.value !== '') {
                // Prevent default action of the enter key
                event.preventDefault();
                // Filter options based on input and select all
                const filteredOptions = props.relationProducts.filter(option =>
                  option.productName.toLowerCase().includes(event.target.value.toLowerCase())
                );
                setProductIds(filteredOptions.map(option => option.id));
                props.setSelectedProductIds(filteredOptions.map(option => option.id));
              }
            }}
          />
        )}
        filterOptions={(options, state: any) => {
          return options.filter(option =>
            option.productName.toLowerCase().includes(state.inputValue.toLowerCase())
          );
        }}
        renderOption={(props: any, option: any) => {
          return <MenuItem key={option.id} value={option.id} >
            <Checkbox
              checked={productIds.includes(option.id)}
              onChange={(event: any) => handleProductChange(option.id)}
            />
            <ListItemText primary={option.productName} />
          </MenuItem>
        }}
        onChange={(event: any, productIds: any) => {
          setProductIds(productIds);
          props.setSelectedProductIds(productIds);
        }}
      />
    </FormControl>
  );
}
export default TableProductsFilter;